import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { ProductsProvider } from '../../contexts';
import { SidebarLayout } from '../../layouts';
import { PermissionsGuard } from './Components';
import { Loader } from './loader.routes';

const ProductsList = Loader(lazy(() => import('../../content/pages/Products/ProductsList')));
const CreateProduct = Loader(lazy(() => import('../../content/pages/Products/ProductCreate')));
const ProductUpdate = Loader(lazy(() => import('../../content/pages/Products/ProductUpdate')));
const ProductBulkCreate = Loader(lazy(() => import('../../content/pages/Products/ProductBulk/ProductBulkCreate')));

export const createProductsRoutes = () => ({
  path: 'products',
  element: <SidebarLayout />,
  children: [
    {
      path: '',
      element: (
        <PermissionsGuard allowedPermissions={['productViewAll']} should404>
          <Navigate to="/products/list" replace />
        </PermissionsGuard>
      )
    },
    {
      path: 'list',
      element: (
        <PermissionsGuard allowedPermissions={['productViewAll']} should404>
          <ProductsProvider>
            <ProductsList />
          </ProductsProvider>
        </PermissionsGuard>
      )
    },
    {
      path: `:productId/update`,
      element: (
        <PermissionsGuard allowedPermissions={['productUpdate']} should404>
          <ProductsProvider>
            <ProductUpdate />
          </ProductsProvider>
        </PermissionsGuard>
      )
    },
    {
      path: 'create',
      element: (
        <PermissionsGuard allowedPermissions={['productCreate']} should404>
          <ProductsProvider>
            <CreateProduct />
          </ProductsProvider>
        </PermissionsGuard>
      )
    },
    {
      path: 'bulk-create',
      element: (
        <PermissionsGuard allowedPermissions={['productCreate']} should404>
          <ProductsProvider>
            <ProductBulkCreate />
          </ProductsProvider>
        </PermissionsGuard>
      )
    }
  ]
});
